import CustomTable from '@myComponents/CustomTable';
import { ListRoads } from '../../../../graphql/Query/roads';
import { DeleteRoad, UpdateRoad, DuplicateRoad } from '../../../../graphql/Mutation/roads';
import { useMutation, useQuery } from '@apollo/client';
import { columns } from './columns';
import { handleConfirmCancel, handleError, handleConfirmDuplicate } from '@components/toast';
import { useNavigate } from 'react-router-dom';
import ModalChallenge from './ModalChallenge';
import { useState } from 'react';

const variables = {
  search: {
    membership: 'EMPTY',
    status: 'EMPTY',
    q: '',
    perPage: 10,
    page: 1,
    pillar: 'EMPTY'
  }
};

const RoadsList = () => {
  const { data, refetch, loading } = useQuery(ListRoads, {
    variables
  });
  const navigate = useNavigate();
  const [deleteRoadById] = useMutation(DeleteRoad);
  const [handleDuplicateRoad] = useMutation(DuplicateRoad);
  
  const [updateRoad] = useMutation(UpdateRoad);
  const [open, setOpenModal] = useState(false);
  const [roadId, setRoadId] = useState('');
  
  const toggleSidebar = () => {
    navigate('/roads/new');
  };

  const handleDelete = async (roadId) => {
    handleConfirmCancel('delete', false, async () => {
      try {
        await deleteRoadById({ variables: { roadId } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  const handleUpdateNew = async (checked, roadId) => {
    try {
      await updateRoad({
        variables: {
          updateRoadInput: {
            _id: roadId,
            data: {
              new: checked
            }
          }
        }
      });
      refetch();
    } catch (e) {
      handleError(e);
    }
  };

  const duplicateRoad = async (data) => {
    handleConfirmDuplicate(true, async () => {
      try {
        await handleDuplicateRoad({ variables: { roadId: data._id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  const getChallenge = async (data) => {
    setRoadId(data._id);
    setOpenModal(true);
  };

  return (
    <>
      <CustomTable
        loading={loading}
        store={data?.listRoads?.docs || []}
        data={{ ...data?.listRoads, docs: undefined }}
        refetch={refetch}
        headerOptions={{
          type: 'add',
          name: 'Crear Camino',
          handle: () => {
            toggleSidebar();
          }
        }}
        filterOptions={{
          types: [
            {
              id: 'pillar',
              name: 'pillar',
              options: [
                {
                  label: 'Filtrar Challenge',
                  value: undefined
                },
                { label: 'Emociones', value: 'EMOTIONS' },
                { label: 'Propósito', value: 'PURPOSE' },
                { label: 'Relaciones', value: 'RELATIONS' },
                { label: 'Autoestima', value: 'SELF_ESTEEM' },
                { label: 'Transformación', value: 'TRANSFORMATION' }
              ],
              type: 'selectOptions'
            },
            {
              id: 'road_membership',
              name: 'membership',
              options: 'membershipOptions',
              type: 'select'
            },
            {
              id: 'road_status',
              name: 'status',
              options: 'statusOptions',
              type: 'select'
            },
            {
              id: 'challenge',
              name: 'challenge',
              options: [
                {
                  label: 'Filtrar Challenge',
                  value: undefined
                },
                {
                  label: 'Activo',
                  value: true
                },
                {
                  label: 'No activo',
                  value: false
                }
              ],
              type: 'selectOptions'
            }
          ]
        }}
        variables={variables}
        columns={columns({
          handleDelete,
          handleUpdateNew,
          navigate,
          getChallenge,
          duplicateRoad
        })}
      />
      {open && (
        <ModalChallenge
          open={open}
          toggleSidebar={() => {
            setOpenModal(!open);
          }}
          roadId={roadId}
        />
      )}
    </>
  );
};

export default RoadsList;
